import React, { Component } from 'react';
import { isEmpty } from "lodash";

import { normalizeStr } from '../../../utils/generalFuncs';
import Dialog from '../../common/Dialog';
import InputText, { InputSelectNative } from '../../common/Form';
import DatePicker from '../../common/DatePicker';

class ProjectForm extends Component {
    state = { 
        project_name: this.props.project ? this.props.project.project_name : "",
        project_desc: this.props.project ? this.props.project.project_desc : "",
        project_amount: this.props.project ? this.props.project.project_amount : "",
        project_start_date: this.props.project ? this.props.project.project_start_date : new Date(),
        project_status: this.props.project ? this.props.project.project_status : "STARTED",
        errors:{
            project_name: "",
            project_desc: "",
            project_start_date: "",
        }
    }
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        
        this.setState({
            [name]: value
        })
    }
    validate = () => {
        let required = [
            "project_name",
            "project_desc",   
            "project_start_date"
        ]
        
        let noError = true
        let errors = {}
        required.map(field => {
            if(!this.state[field]){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
    
        this.setState({
            errors
        })
        return noError
    }
    
    nameExist = (name, id) => {
        const { PROJECTS } = this.props;
        let list = []
        list = Object.values(PROJECTS).filter(item =>  ( 
            (normalizeStr(item.project_name) === normalizeStr(name) ) && 
            (item.project_id !== id) 
        ) )
            
        console.log("Item exist",{list});
        return !isEmpty(list)
    }
    handleSubmit = async () => {
        if(this.validate()){
            let data = {}
            if (this.props.update) {
                data = Object.assign(data, this.props.project)
            }
            data.project_name = this.state.project_name
            data.project_desc = this.state.project_desc
            data.project_start_date = this.state.project_start_date
            data.project_amount = parseFloat(this.state.project_amount)
            data.project_status = this.state.project_status
    
            console.log('====================================');
            console.log({data});
            console.log('====================================');
            
            // check if name exist
            if(this.nameExist(data.project_name, data.project_id) ){
                this.props.notif("error",`Ce Projet existe déjà`)
                return
            }

            if(this.props.update){
                await this.props.updateProject(data)
            } else {
                await this.props.newProject(data)  
            }

            if(this.props.STATE.projects.error){
                console.log('====================================');
                console.log("ERROR", this.props.STATE.projects );
                console.log('====================================');
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.projects.error}`)
            } else {
                !this.props.update && this.props.notif("success","Le projet a été créé avec succès")
                this.props.update && this.props.notif("success","Le projet a été modifié avec succès")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs" )
        }
    }
    render() {
        return (
            <Dialog
                close={this.props.handleClose}
                // fullScreen
                title={`${this.props.update ? "Modifier le " : "Créer un nouveau"} Projet`}
                submitAction={this.handleSubmit} 
                disabledSubmit={this.props.STATE.projects.fetching}
                submitTitle={this.props.update ? "Modifier" : "Créer"}
            >
                <InputText
                    required
                    name="project_name" 
                    id="project_name" 
                    value={this.state.project_name} 
                    label="Nom" 
                    placeholder="Nom du projet" 
                    error={this.state.errors.project_name} 
                    onChange={this.handleChange}
                />
                <InputText
                    required
                    type="number" // TODO add regex
                    name="project_amount" 
                    id="project_amount" 
                    value={this.state.project_amount} 
                    label="Montant" 
                    placeholder="Montant Total du Projet" 
                    error={this.state.errors.project_amount} 
                    onChange={this.handleChange}
                />

                <DatePicker
                    required
                    name="project_start_date" 
                    id="project_start_date" 
                    value={this.state.project_start_date} 
                    label="Démarrage projet" 
                    error={this.state.errors.project_start_date} 
                    handleChange={(date) => this.setState({ project_start_date: date}) } 
                />
                <InputSelectNative
                    required
                    name="project_status" 
                    id="project_status" 
                    value={this.state.project_status} 
                    label="Statut du projet" 
                    error={this.state.errors.project_status} 
                    onChange={this.handleChange}
                    options={[
                        <option key="PLANNED" value="PLANNED">Planifié</option>,
                        <option key="STARTED" value="STARTED">Démarré</option>,
                        <option key="FINISHED" value="FINISHED">Terminé</option>,
                        <option key="ARCHIVED" value="ARCHIVED">Archivé</option>
                    ]}
                />
                <InputText
                    required
                    name="project_desc" 
                    id="project_desc" 
                    value={this.state.project_desc} 
                    label="Description" 
                    placeholder="Description du projet" 
                    error={this.state.errors.project_desc} 
                    onChange={this.handleChange}
                    multiline
                    rows={3}
                />
                    
            </Dialog>

        );
    }
}

export default ProjectForm;